import React from "react";

export default function AppShell({ children }) {
    return (
        <div className="App min-h-screen bg-cream text-ink">
            <div className="w-full max-w-md mx-auto min-h-screen relative bg-cream sm:shadow-2xl sm:my-0 flex flex-col overflow-x-clip">
                {children}
            </div>
        </div>
    );
}
